import React, { useEffect, FC } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { useGlobalDispatch } from "./context/Provider";
import Sku from "./containers/sku";
import Warehouse from "./containers/warehouse";
import Product from "./containers/product";
import ActionProduct from "./containers/actionProduct";
import Transfer from "./containers/transfers";
import History from "./containers/history";
import WarehouseAccess from "./containers/warehouseAccess";
import Panel from "./containers/panel";
import Landing from "./containers/landing";
import Login from "./containers/login/login.container";
import LoginCallback from "./containers/login/login.call.back";
import AcceptanceAction from "./containers/acceptanceAction";
import { changeLanguages } from "./context/lang/lang.action";
import StoreRequestion from "./containers/storeRStoreRequisition";

const App: FC = () => {
  const { langDispatch }: any = useGlobalDispatch();

  const handleGetLang = () => {
    const currentLang = localStorage.getItem("lang");
    if (currentLang) {
      langDispatch(changeLanguages({ lang: currentLang }));
    }
  };

  useEffect(() => {
    handleGetLang();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<Navigate to="landing" />} />
        <Route path="panel" element={<Panel />}>
          <Route path="sku" element={<Sku />} />
          <Route path="product" element={<Product />} />
          <Route path="warehouse" element={<Warehouse />} />
          <Route path="transfer" element={<Transfer />} />
          <Route path="warehouseAccess" element={<WarehouseAccess />} />
          <Route path="store-requisition" element={<StoreRequestion />} />
          <Route
            path=":activeSection/:type/:skuId"
            element={<ActionProduct />}
          />
          <Route path="invetory-history" element={<History />} />
          <Route
            path=":activeSection/acceptanceOfAction/:actionType"
            element={<AcceptanceAction />}
          />
        </Route>
        <Route path="landing" element={<Landing />} />
        <Route path="login" element={<Login />} />
        <Route
          path="authentication/login-callback"
          element={<LoginCallback />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
